module.exports = require("@splunk/dashboard-visualizations/SingleValueIcon");